import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import moment from "moment";
import { deepCopy, sum, getUnique, getCorrectValue, checkProperValue, convertToPercent, getCompsetMedian, getHelperData, round, transformHotelForecastItem, transformMarketForecastItem } from "../../app/util"
import { Button, Tooltip } from "@mui/material";
import TableToExcel from "@linways/table-to-excel";
import { DeblurRounded, TurnedIn } from '@mui/icons-material';

export function getTotals(data = [], meta) {
    const { type } = meta;
    let totalRow = {};
    let capacity = 0;
    let totalCapacity = 0;
    // debugger;
    data.forEach((item, index) => {
        item.forEach((kpi, ind) => {
            totalRow[kpi.id] = totalRow[kpi.id] ? totalRow[kpi.id] : {};

            if (kpi.id !== "staydates") {
                let kpis = Object.keys(kpi);

                if (kpi.RevPAR > 0) {
                    if (!capacity) {
                        capacity = Math.round(kpi.Revenue / kpi.RevPAR);
                        totalCapacity = capacity;
                    }
                }

                kpis.forEach(kpiKey => {
                    if (kpiKey !== 'id') {
                        totalRow[kpi.id][kpiKey] = totalRow[kpi.id][kpiKey] ? totalRow[kpi.id][kpiKey] : 0;
                        kpi[kpiKey] = (kpi[kpiKey]) ? kpi[kpiKey] : 0;
                        totalRow[kpi.id][kpiKey] += kpi[kpiKey];
                        // if (isNaN(totalRow[kpi.id][kpiKey])) {
                        //     totalRow[kpi.id][kpiKey] = 0;
                        // }
                    }
                    if (['compdate', 'id'].includes(kpiKey)) {
                        totalRow[kpi.id][kpiKey] = kpi[kpiKey];
                    }
                });

                totalRow[kpi.id].ADR = totalRow[kpi.id].Revenue / totalRow[kpi.id].Rooms;
                totalRow[kpi.id].Occ = convertToPercent(totalRow[kpi.id].Rooms / totalCapacity);
                totalRow[kpi.id].RevPAR = totalRow[kpi.id].Revenue / totalCapacity;

                // totalRow[kpi.id] = deepCopy(kpisTotal);                  

            } else if (kpi.id === "staydates") {
                totalRow[kpi.id] = deepCopy(kpi);
                totalRow[kpi.id].segment = "Total";
                // debugger;
            }
        });
        if (type === 'Total') {
            if (capacity > 0) {
                totalCapacity += capacity;
            }
            totalRow.staydates.date = '';
            totalRow.staydates.dow = '';
        }
    });
    // debugger;
    let rowArr = [];
    for (let k in totalRow) {
        // totalRow[k].id = k;
        rowArr.push(totalRow[k]);
    }
    return rowArr;
}

/*
- This function is used to generalize data into simple format so that 
- filter and sorting operations can be done easily in optimized way.
- This will support forecast data format coming from DS API
*/
export function generalizeForecastData(params) {
    const { data, capacity, filters } = params;
    let start = moment().format("x");
    let blankKpis = { Rooms: 0, Occ: 0, ADR: 0, Revenue: 0, RevPAR: 0 };
    const filteredHotelSegments = ['all'];
    const filteredMarketSegments = ['all'];
    const totals = { grand: {}, segments: {}, capacity: 0 };
    let segmentSortidentifier = 'primary';
    const dates = [];
    const hotelForecastKeys = {};
    // debugger;
    let transformed = [];
    data.map((item, i) => {
        let date = item.stay_date;
        let keys = Object.keys(item);
        let totalKey = keys.includes('market_segment') ? 'MarketTotal' : 'HotelTotal';

        let dateItemObj = {
            index: { date: date },
            segmented: [],
            total: {}
        }

        if (!dates.includes(date)) {
            dates.push(date);
            let sameDateData = data.filter(item => item.stay_date === date);
            totals.capacity += item.capacity;

            //Transforeming for Market forecast
            if (keys.includes('market_segment')) {
                // debugger;
                //setting up total
                totals.grand.primary = totals.grand.primary ? totals.grand.primary : deepCopy(blankKpis);
                totals.grand.forecast_cons = totals.grand.forecast_cons ? totals.grand.forecast_cons : deepCopy(blankKpis);
                totals.grand.forecast_uncons = totals.grand.forecast_uncons ? totals.grand.forecast_uncons : deepCopy(blankKpis);

                dateItemObj[totalKey] = dateItemObj[totalKey] ? dateItemObj[totalKey] : { primary: deepCopy(blankKpis), forecast_cons: deepCopy(blankKpis), forecast_uncons: deepCopy(blankKpis) };
                dateItemObj.total.primary = deepCopy(blankKpis);
                dateItemObj.total.forecast_cons = deepCopy(blankKpis);
                dateItemObj.total.forecast_uncons = deepCopy(blankKpis);


                //setting MarketTotal for forecast
                keys.map((key) => {
                    if (key.indexOf('predicted_') > -1) {
                        let k = key.split('_');
                        if (k[1] === 'total' && k[2] === 'cons') {
                            for (let kpi in dateItemObj[totalKey].primary) {
                                // debugger;
                                dateItemObj[totalKey].primary[kpi] = item[k[0] + '_' + k[1] + '_' + k[2] + "_" + kpi.toLocaleLowerCase()];
                                dateItemObj[totalKey].forecast_cons[kpi] = item[k[0] + '_' + k[1] + '_' + k[2] + "_" + kpi.toLocaleLowerCase()];
                            }
                        }
                        if (k[1] === 'total' && k[2] === 'uncons') {
                            for (let kpi in dateItemObj[totalKey].primary) {
                                dateItemObj[totalKey].forecast_uncons[kpi] = item[k[0] + '_' + k[1] + '_' + k[2] + "_" + kpi.toLocaleLowerCase()];
                            }
                        }
                    }
                });

                sameDateData.map((item, i) => {
                    let segmentCode = item.market_segment;
                    if (filteredHotelSegments.length && (filteredHotelSegments.includes(segmentCode) || filteredHotelSegments.includes('all'))) {
                        // dateItemObj.total = dateItemObj.total ? dateItemObj.total : { forecast: deepCopy(blankKpis), forecast_cons: deepCopy(blankKpis), forecast_uncons: deepCopy(blankKpis) };
                        let segmentObj = { name: segmentCode, value: {} };
                        segmentObj.value.primary = deepCopy(blankKpis);
                        segmentObj.value.forecast_cons = deepCopy(blankKpis);
                        segmentObj.value.forecast_uncons = deepCopy(blankKpis);

                        totals.segments[segmentCode] = totals.segments[segmentCode] ? totals.segments[segmentCode] : {};
                        totals.segments[segmentCode].primary = totals.segments[segmentCode].primary ? totals.segments[segmentCode].primary : deepCopy(blankKpis);
                        totals.segments[segmentCode].forecast_cons = totals.segments[segmentCode].forecast_cons ? totals.segments[segmentCode].forecast_cons : deepCopy(blankKpis);
                        totals.segments[segmentCode].forecast_uncons = totals.segments[segmentCode].forecast_uncons ? totals.segments[segmentCode].forecast_uncons : deepCopy(blankKpis);

                        if (keys.indexOf('predicted_cons_rooms') > -1) {
                            let k = "predicted_cons_rooms".split('_');
                            if (k[1] === 'cons') {
                                for (let kpi in segmentObj.value.primary) {
                                    //Key will be lik predicted_cons_adr
                                    segmentObj.value.primary[kpi] = item[k[0] + '_' + k[1] + '_' + kpi.toLocaleLowerCase()];
                                    segmentObj.value.forecast_cons[kpi] = item[k[0] + '_' + k[1] + '_' + kpi.toLocaleLowerCase()];

                                    // if(kpi=='Rooms') debugger;
                                    dateItemObj.total.primary[kpi] += segmentObj.value.primary[kpi]
                                    dateItemObj.total.forecast_cons[kpi] += segmentObj.value.forecast_cons[kpi];

                                    totals.segments[segmentCode].primary[kpi] += segmentObj.value.primary[kpi];
                                    totals.segments[segmentCode].forecast_cons[kpi] += segmentObj.value.forecast_cons[kpi];

                                    totals.grand.primary[kpi] += segmentObj.value.primary[kpi];
                                    totals.grand.forecast_cons[kpi] += segmentObj.value.forecast_cons[kpi];
                                }
                                //Recalculating ADR
                                dateItemObj.total.primary.ADR = dateItemObj.total.primary.Revenue / dateItemObj.total.primary.Rooms;
                                dateItemObj.total.forecast_cons.ADR = dateItemObj.total.forecast_cons.Revenue / dateItemObj.total.forecast_cons.Rooms;

                                totals.segments[segmentCode].primary.ADR = totals.segments[segmentCode].primary.Revenue / totals.segments[segmentCode].primary.Rooms;
                                totals.segments[segmentCode].forecast_cons.ADR = totals.segments[segmentCode].forecast_cons.Revenue / totals.segments[segmentCode].forecast_cons.Rooms;

                                totals.grand.primary.ADR = totals.grand.primary.Revenue / totals.grand.primary.Rooms;
                                totals.grand.forecast_cons.ADR = totals.grand.forecast_cons.Revenue / totals.grand.forecast_cons.Rooms;

                                //Recalculating RevPAR
                                totals.grand.primary.RevPAR = totals.grand.primary.Revenue / totals.capacity;
                                totals.grand.forecast_cons.RevPAR = totals.grand.forecast_cons.Revenue / totals.capacity;

                                //Recalculating Occ 
                                totals.grand.primary.Occ = totals.grand.primary.Rooms / totals.capacity;
                                totals.grand.forecast_cons.Occ = totals.grand.forecast_cons.Rooms / totals.capacity;
                                totals.segments[segmentCode].primary.Occ = totals.segments[segmentCode].primary.Rooms / totals.capacity;
                                totals.segments[segmentCode].forecast_cons.Occ = totals.segments[segmentCode].forecast_cons.Rooms / totals.capacity;
                            }
                        }

                        if (keys.indexOf('predicted_uncons_rooms') > -1) {
                            let k = "predicted_uncons_rooms".split('_');
                            if (k[1] === 'uncons') {
                                for (let kpi in segmentObj.value.primary) {
                                    //Key will be like predicted_cons_adr
                                    segmentObj.value.forecast_uncons[kpi] = item[k[0] + '_' + k[1] + '_' + kpi.toLocaleLowerCase()];

                                    dateItemObj.total.forecast_uncons[kpi] += item[k[0] + '_' + k[1] + '_' + kpi.toLocaleLowerCase()];

                                    totals.grand.forecast_uncons[kpi] += dateItemObj.total.forecast_uncons[kpi];

                                    totals.segments[segmentCode].forecast_uncons[kpi] += segmentObj.value.forecast_uncons[kpi];
                                }
                                //Recalculating ADR
                                dateItemObj.total.forecast_uncons.ADR = dateItemObj.total.forecast_uncons.Revenue / dateItemObj.total.forecast_uncons.Rooms;
                                totals.segments[segmentCode].forecast_uncons.ADR = totals.segments[segmentCode].forecast_uncons.Revenue / totals.segments[segmentCode].forecast_uncons.Rooms;
                                totals.grand.forecast_uncons.ADR = totals.grand.forecast_uncons.Revenue / totals.grand.forecast_uncons.Rooms;

                                //Recalculating RevPAR
                                totals.grand.forecast_uncons.RevPAR = totals.grand.primary.Revenue / totals.capacity;

                                //Recalculating Occ 
                                totals.grand.forecast_uncons.Occ = totals.grand.forecast_uncons.Rooms / totals.capacity;
                                totals.segments[segmentCode].forecast_uncons.Occ = totals.segments[segmentCode].forecast_uncons.Rooms / totals.capacity;
                                totals.segments[segmentCode].forecast_uncons.Occ = totals.segments[segmentCode].forecast_uncons.Rooms / totals.capacity;
                            }
                        }

                        dateItemObj.segmented.push(segmentObj);
                        // dateItemObj.total
                    }
                });
                dateItemObj.segmented.sort((a, b) => b.value[segmentSortidentifier].Rooms - a.value[segmentSortidentifier].Rooms);
                transformed.push(dateItemObj);
            }

            //Transforeming for Hotel forecast
            if (keys.includes('hotel_segment')) {
                //setting up total
                totals.grand.primary = totals.grand.primary ? totals.grand.primary : deepCopy(blankKpis);
                totals.grand.forecast_cons = totals.grand.forecast_cons ? totals.grand.forecast_cons : deepCopy(blankKpis);
                totals.grand.forecast_uncons = totals.grand.forecast_uncons ? totals.grand.forecast_uncons : deepCopy(blankKpis);

                dateItemObj[totalKey] = dateItemObj[totalKey] ? dateItemObj[totalKey] : { primary: deepCopy(blankKpis), forecast_cons: deepCopy(blankKpis), forecast_uncons: deepCopy(blankKpis) };
                dateItemObj.total.primary = deepCopy(blankKpis);
                dateItemObj.total.forecast_cons = deepCopy(blankKpis);
                dateItemObj.total.forecast_uncons = deepCopy(blankKpis);


                //setting HotelTotal for forecast
                keys.map((key) => {
                    if (key.indexOf('predicted_') > -1) {
                        let k = key.split('_');
                        if (k[1] === 'total' && k[2] === 'cons') {
                            for (let kpi in dateItemObj[totalKey].primary) {
                                // debugger;
                                dateItemObj[totalKey].primary[kpi] = item[k[0] + '_' + k[1] + '_' + k[2] + "_" + kpi.toLocaleLowerCase()];
                                dateItemObj[totalKey].forecast_cons[kpi] = item[k[0] + '_' + k[1] + '_' + k[2] + "_" + kpi.toLocaleLowerCase()];
                            }
                        }
                        if (k[1] === 'total' && k[2] === 'uncons') {
                            for (let kpi in dateItemObj[totalKey].primary) {
                                dateItemObj[totalKey].forecast_uncons[kpi] = item[k[0] + '_' + k[1] + '_' + k[2] + "_" + kpi.toLocaleLowerCase()];
                            }
                        }
                    }
                });

                sameDateData.map((item, i) => {
                    let segmentCode = item.market_code;
                    if (filteredHotelSegments.length && (filteredHotelSegments.includes(segmentCode) || filteredHotelSegments.includes('all'))) {
                        // dateItemObj.total = dateItemObj.total ? dateItemObj.total : { forecast: deepCopy(blankKpis), forecast_cons: deepCopy(blankKpis), forecast_uncons: deepCopy(blankKpis) };
                        let segmentObj = { name: segmentCode, value: {} };
                        segmentObj.value.primary = deepCopy(blankKpis);
                        segmentObj.value.forecast_cons = deepCopy(blankKpis);
                        segmentObj.value.forecast_uncons = deepCopy(blankKpis);

                        totals.segments[segmentCode] = totals.segments[segmentCode] ? totals.segments[segmentCode] : {};
                        totals.segments[segmentCode].primary = totals.segments[segmentCode].primary ? totals.segments[segmentCode].primary : deepCopy(blankKpis);
                        totals.segments[segmentCode].forecast_cons = totals.segments[segmentCode].forecast_cons ? totals.segments[segmentCode].forecast_cons : deepCopy(blankKpis);
                        totals.segments[segmentCode].forecast_uncons = totals.segments[segmentCode].forecast_uncons ? totals.segments[segmentCode].forecast_uncons : deepCopy(blankKpis);

                        if (keys.indexOf('predicted_cons_rooms') > -1) {
                            let k = "predicted_cons_rooms".split('_');
                            if (k[1] === 'cons') {
                                for (let kpi in segmentObj.value.primary) {
                                    //Key will be lik predicted_cons_adr
                                    segmentObj.value.primary[kpi] = item[k[0] + '_' + k[1] + '_' + kpi.toLocaleLowerCase()];
                                    segmentObj.value.forecast_cons[kpi] = item[k[0] + '_' + k[1] + '_' + kpi.toLocaleLowerCase()];

                                    // if(kpi=='Rooms') debugger;
                                    dateItemObj.total.primary[kpi] += segmentObj.value.primary[kpi]
                                    dateItemObj.total.forecast_cons[kpi] += segmentObj.value.forecast_cons[kpi];

                                    totals.segments[segmentCode].primary[kpi] += segmentObj.value.primary[kpi];
                                    totals.segments[segmentCode].forecast_cons[kpi] += segmentObj.value.forecast_cons[kpi];

                                    totals.grand.primary[kpi] += segmentObj.value.primary[kpi];
                                    totals.grand.forecast_cons[kpi] += segmentObj.value.forecast_cons[kpi];
                                }
                                //Recalculating ADR
                                dateItemObj.total.primary.ADR = dateItemObj.total.primary.Revenue / dateItemObj.total.primary.Rooms;
                                dateItemObj.total.forecast_cons.ADR = dateItemObj.total.forecast_cons.Revenue / dateItemObj.total.forecast_cons.Rooms;

                                totals.segments[segmentCode].primary.ADR = totals.segments[segmentCode].primary.Revenue / totals.segments[segmentCode].primary.Rooms;
                                totals.segments[segmentCode].forecast_cons.ADR = totals.segments[segmentCode].forecast_cons.Revenue / totals.segments[segmentCode].forecast_cons.Rooms;

                                totals.grand.primary.ADR = totals.grand.primary.Revenue / totals.grand.primary.Rooms;
                                totals.grand.forecast_cons.ADR = totals.grand.forecast_cons.Revenue / totals.grand.forecast_cons.Rooms;

                                //Recalculating RevPAR
                                totals.grand.primary.RevPAR = totals.grand.primary.Revenue / totals.capacity;
                                totals.grand.forecast_cons.RevPAR = totals.grand.forecast_cons.Revenue / totals.capacity;

                                //Recalculating Occ 
                                totals.grand.primary.Occ = totals.grand.primary.Rooms / totals.capacity;
                                totals.grand.forecast_cons.Occ = totals.grand.forecast_cons.Rooms / totals.capacity;
                                totals.segments[segmentCode].primary.Occ = totals.segments[segmentCode].primary.Rooms / totals.capacity;
                                totals.segments[segmentCode].forecast_cons.Occ = totals.segments[segmentCode].forecast_cons.Rooms / totals.capacity;
                            }
                        }

                        if (keys.indexOf('predicted_uncons_rooms') > -1) {
                            let k = "predicted_uncons_rooms".split('_');
                            if (k[1] === 'uncons') {
                                for (let kpi in segmentObj.value.primary) {
                                    //Key will be like predicted_cons_adr
                                    segmentObj.value.forecast_uncons[kpi] = item[k[0] + '_' + k[1] + '_' + kpi.toLocaleLowerCase()];

                                    dateItemObj.total.forecast_uncons[kpi] += item[k[0] + '_' + k[1] + '_' + kpi.toLocaleLowerCase()];

                                    totals.grand.forecast_uncons[kpi] += dateItemObj.total.forecast_uncons[kpi];

                                    totals.segments[segmentCode].forecast_uncons[kpi] += segmentObj.value.forecast_uncons[kpi];
                                }
                                //Recalculating ADR
                                dateItemObj.total.forecast_uncons.ADR = dateItemObj.total.forecast_uncons.Revenue / dateItemObj.total.forecast_uncons.Rooms;
                                totals.segments[segmentCode].forecast_uncons.ADR = totals.segments[segmentCode].forecast_uncons.Revenue / totals.segments[segmentCode].forecast_uncons.Rooms;
                                totals.grand.forecast_uncons.ADR = totals.grand.forecast_uncons.Revenue / totals.grand.forecast_uncons.Rooms;

                                //Recalculating RevPAR
                                totals.grand.forecast_uncons.RevPAR = totals.grand.primary.Revenue / totals.capacity;

                                //Recalculating Occ 
                                totals.grand.forecast_uncons.Occ = totals.grand.forecast_uncons.Rooms / totals.capacity;
                                totals.segments[segmentCode].forecast_uncons.Occ = totals.segments[segmentCode].forecast_uncons.Rooms / totals.capacity;
                                totals.segments[segmentCode].forecast_uncons.Occ = totals.segments[segmentCode].forecast_uncons.Rooms / totals.capacity;
                            }
                        }

                        dateItemObj.segmented.push(segmentObj);
                        // dateItemObj.total
                    }
                });
                dateItemObj.segmented.sort((a, b) => b.value[segmentSortidentifier].Rooms - a.value[segmentSortidentifier].Rooms);
                transformed.push(dateItemObj);
            }
        }
    });
    // debugger;
    return {
        totals,
        data: transformed
    }
    console.log("time taken:", moment().format("x") - start, totals, transformed);
}

/*
- This function is used to generalize data into simple format so that 
- filter and sorting operations can be done easily in optimized way.
- This may not support all data coming from API but most of them should work like OSR, Market and 
- data coming for report sections.
*/
export function generalizeData(params) {
    const { data, capacity, filters, columns, data_id, segments, workspace_controls, stayDates, helperData, tile } = params;
    let blankKpis = { Rooms: 0, Occ: 0, ADR: 0, Revenue: 0, RevPAR: 0 };
    // debugger;
    //Coollecting CODES of Other segments
    let segment_others = [];
    let other_codes = [];
    let Other_segments = segments.list.filter(item => {
        if (item.name === 'Other') {
            if(!other_codes.includes(item.code)){
                other_codes.push(item.code);
            }            
            return true;
        }
    });
    segments.list.map((item) => { if (item.name === "Other" && filters.segments.includes('Other')) segment_others.push(item.code) });

    //Getting the columns mainKeys
    const mainKeys = [];
    const columnDetails = [];
    columns.map((column) => {
        if (column.type === "dataColumn") {
            columnDetails.push(column);
            mainKeys.push(column.tileName + '->' + column.id + '->' + column.mainKey);
        }
    });
    //End

    let compset_median_col = columns.find((col) => col.id === "compset_medium");
    let market_sell_rates = columns.find((col) => col.tileName === "market_sell_rates");

    let identifiers = getUnique(mainKeys);
    
    let start = moment().format("x");

    // const filteredSegments = ['GASC', 'TBAR', 'TFIT'];
    const totals = { grand: {}, segments: {}, capacity: 0 };
    let ignoreIdentities = [];
    let [tileName, columnId, identity] = identifiers[0].split('->');
    let segmentSortidentifier = identity;
    let transformed = [];
    const datesDba = workspace_controls.scopeType === 'Date' ? stayDates : [-1].concat(Array.from(Array(Number(workspace_controls.dba)).keys()));
    const date_dba = workspace_controls.scopeType.toLocaleLowerCase();
    // debugger;
    if(!data.length){
        return {data: [], totals: {}}
    }
    datesDba.map((d, i) => {
        let original_item = data.filter(item => {
            let item_date = '';
            let index = item.index || item.Index;
            if (!item.stay_date && index) {
                item_date = index[date_dba];
                if (date_dba === 'date' && item_date && moment(item_date).format('YYYY-MM-DD') === d) {
                    return true;
                } else if (item_date === d) {
                    return true;
                }
            }
            if (item.stay_date) {
                item_date = item.stay_date;
            }
        });
        // debugger;
        let helperDataItems = [];
        if (helperData && date_dba !== 'dba') {
            helperDataItems = helperData.filter(item => item.stay_date && moment(item.stay_date).isSame(d, 'day'));
        }
        if (original_item.length && original_item.length === 1) {
            if (helperDataItems.length === 1) {

            }
            //Futures data
            if (!helperDataItems.length) {
                if (tile === 'market') {
                    let keys = Object.keys(original_item[0]);
                    keys.forEach((key) => {
                        if (key !== 'index') {
                            original_item[0][key].market_projected = deepCopy(original_item[0][key].primary);
                        }
                    });
                }
            }
            if (helperDataItems.length > 1) {
                const forcastMarketCodes = helperDataItems.map((item) => item.market_code);
                if(tile !== 'market'){
                    original_item[0] = {HotelTotal: original_item[0].HotelTotal, index: original_item[0].index};
                }
                forcastMarketCodes.forEach((code) => {
                    original_item[0]['Segment_'+code] =original_item[0]['Segment_'+code] ? original_item[0]['Segment_'+code] : {};
                });
                helperDataItems.forEach((item) => {
                    let tmp = {};
                    if (tile === 'forecast') {
                        let segmentCodeKey = 'market_code';
                        let segmentCode = item[segmentCodeKey];
                        tmp['Segment_' + segmentCode] = transformHotelForecastItem(item);
                        tmp['Segment_' + segmentCode] = tmp['Segment_' + segmentCode] ? tmp['Segment_' + segmentCode] : {};
                        tmp['Segment_' + segmentCode].primary = deepCopy(tmp['Segment_' + segmentCode].forecast);
                        original_item[0]['Segment_' + segmentCode] =  {};
                        original_item[0]['Segment_' + segmentCode].primary = deepCopy(tmp['Segment_' + segmentCode].forecast);
                        if (workspace_controls.unconstrained) {
                            original_item[0]['Segment_' + segmentCode].primary = deepCopy(tmp['Segment_' + segmentCode].forecast_uncons);
                        }
                        // debugger; 
                        // tmp['HotelTotal'] = deepCopy(tmp['Segment_' + segmentCode].forecast);
                    }

                    if (tile === 'market') {
                        original_item[0].index = original_item[0].Index || original_item[0].index;
                        let segmentCodeKey = 'market_segment';
                        let segmentCode = item[segmentCodeKey];
                        tmp['MarketSegment_' + segmentCode] = transformMarketForecastItem(item);
                        original_item[0]['MarketSegment_' + segmentCode].market_projected = deepCopy(tmp['MarketSegment_' + segmentCode].forecast);
                        original_item[0]['MarketTotal'].market_projected = deepCopy(tmp['MarketSegment_' + segmentCode].forecast);
                        
                        if (workspace_controls.unconstrained) {
                            original_item[0]['MarketSegment_' + segmentCode].market_projected = deepCopy(tmp['MarketSegment_' + segmentCode].forecast_uncons);
                        }
                    }
                });
            }
            original_item = original_item[0];
        }

        let totalKey = Object.keys(original_item).filter((key) => key.indexOf('Total') > -1);
        totalKey = totalKey.length ? totalKey[0] : null;
        let segmented = [];
        let total = {};
        let item = {};

        //Aggregating all segment code mapped to Other 
        let segmentKeys = Object.keys(original_item);
        let keysStr = segmentKeys.join(' ');
        let hasSegmented = keysStr.indexOf('Segment_') > -1;
        if (segments.list.length) {
            segmentKeys.map((key) => {
                let keys = key.split('Segment_');
                let segmentSplit = key.split('Segment_');
                let segmentSplitter = segmentSplit[1] ? segmentSplit[0] + 'Segment_' : 'Segment_';
                let segmentCode = key.split(segmentSplitter)[1];
                
                if (segmentCode && (other_codes.includes(segmentCode) || !segments.map[segmentCode])) {
                    item['Segment_Other'] = item['Segment_Other'] ? item['Segment_Other'] : {};
                    let identifiers = Object.keys(original_item[totalKey]);
                    identifiers.map((identity, i) => {
                        // const [tileName, columnId, identity] = unique_identity.split('->');
                        item['Segment_Other'][identity] = item['Segment_Other'][identity] ? item['Segment_Other'][identity] : {};
                        if (original_item['Segment_' + segmentCode][identity]) {
                            let kpis = Object.keys(original_item['Segment_' + segmentCode][identity]);
                            kpis.map((kpi) => {
                                if (kpi !== 'date') {
                                    // if(identity=='primary' && kpi=='Rooms' && original_item['Segment_' + segmentCode][identity][kpi]>0){ let t = original_item['Segment_' + segmentCode][identity][kpi]; debugger}
                                    item['Segment_Other'][identity][kpi] = sum(checkProperValue(item['Segment_Other'][identity][kpi]), Number(original_item['Segment_' + segmentCode][identity][kpi]), 4);
                                } else {
                                    item['Segment_Other'][identity][kpi] = original_item['Segment_' + segmentCode][identity][kpi];
                                }
                            });
                            // segmentCode = segment_others.includes(segmentCode) ? 'Other' : segmentCode;
                        }
                    });
                } else if (segmentCode && !other_codes.includes(segmentCode) && segments.map[segmentCode]) {
                    item['Segment_' + segmentCode] = original_item['Segment_' + segmentCode];
                } else {
                    item[keys[0]] = original_item[keys[0]];
                }
            });
        }
        //End of aggregation

        if (original_item[totalKey] && original_item[totalKey].primary && original_item[totalKey].primary.Revenue) {
            if (!total.capacity) {
                total.capacity = Math.round(original_item[totalKey].primary.Revenue / original_item[totalKey].primary.RevPAR);
            }
            totals.capacity += total.capacity;
        }
        //  else {
        //     total.capacity = 0;
        //     totals.capacity = 0;
        // }

        // Adding Other as segment; 
        if (!filters.segments.includes('Other')) filters.segments.push('Other');

        //Looping through the properties of the data items
        // debugger;
        if (!Object.keys(item).length) {
            item = original_item;
            item.index = original_item.index || original_item.Index;
        }
        let keys = Object.keys(item);
        // let keysStr = keys.join(' ');
        // let hasSegmented = keysStr.indexOf('Segment_') > -1;
        //Getting date or dba
        // debugger;
        let date = date_dba === 'date' && item.index ? item.index.date : null;
        let dba = date_dba === 'dba' ? item.index.dba : null;
        if (item.stay_date) date = item.stay_date;
        // if (!item.stay_date) { }
        keys.map((key) => {
            let segmentSplit = key.split('Segment_');
            let segmentSplitter = segmentSplit[1] ? segmentSplit[0] + 'Segment_' : 'Segment_';
            let segmentCode = key.split(segmentSplitter)[1];

            identifiers.map((unique_identity, i) => {
                const [tileName, columnId, identity] = unique_identity.split('->');
                //Putting this identity for main calculations ignore list                  
                if (original_item[totalKey] && !original_item[totalKey][identity] && !ignoreIdentities.includes(identity)) ignoreIdentities.push(identity);
            });

            //Only do this for segments type properties of the data items
            if (hasSegmented && segmentCode && filters && filters.segments && (filters.segments.includes('all') || filters.segments.includes(segmentCode))) {
                let tmp = {};
                totals.segments[segmentCode] = totals.segments[segmentCode] ? totals.segments[segmentCode] : {};
                tmp.name = segmentCode;
                tmp.value = deepCopy(item[key]);
                // debugger;
                //snippet for calculating segmented grand totals
                let allidentifiers = Object.keys(tmp.value);
                //debugger;
                allidentifiers.map((identity, i) => {
                    if (tmp.value[identity] && !ignoreIdentities.includes(identity)) {
                        // let totalsSegmentsIdentity = totalsSegments[segmentCode] ? totalsSegments[segmentCode] : {};
                        totals.segments[segmentCode][identity] = totals.segments[segmentCode][identity] ? totals.segments[segmentCode][identity] : {};
                        let kpis = Object.keys(tmp.value[identity]);
                        kpis.map((kpi) => {
                            if (kpi === 'Occ') {
                                tmp.value[identity][kpi] = convertToPercent(tmp.value[identity][kpi]);
                            }
                            tmp.value[identity][kpi] = Number(tmp.value[identity][kpi]);
                            let kpi_val = tmp.value[identity][kpi];

                            totals.segments[segmentCode][identity][kpi] = totals.segments[segmentCode][identity][kpi] ? totals.segments[segmentCode][identity][kpi] : 0;

                            if (!['date', 'ADR'].includes(kpi)) {
                                totals.segments[segmentCode][identity][kpi] = sum(checkProperValue(totals.segments[segmentCode][identity][kpi]), Number(kpi_val), 4);
                            }
                            //Do for pace comparison date
                            // debugger;
                            if (kpi === 'date') {
                                tmp.value[identity].compdate = item[key][identity][kpi];
                                delete tmp.value[identity].date;
                            }
                        });
                        //Calculating ADR, becasue ADR, Occ, RevPAR calculation formula is Revenue/Room sold
                        totals.segments[segmentCode][identity].ADR = !isNaN(totals.segments[segmentCode][identity].Revenue / totals.segments[segmentCode][identity].Rooms) ? totals.segments[segmentCode][identity].Revenue / totals.segments[segmentCode][identity].Rooms : 0;
                        totals.segments[segmentCode][identity].Occ = !isNaN(totals.segments[segmentCode][identity].Rooms / totals.capacity) ? totals.segments[segmentCode][identity].Rooms / totals.capacity : 0;
                        totals.segments[segmentCode][identity].Occ = convertToPercent(totals.segments[segmentCode][identity].Occ);
                    }
                });

                ignoreIdentities.map((identity, i) => {
                    // const [tileName, columnId, identity] = unique_identity.split('->');
                    //Do this for custom calculations from table-config
                    totals.segments[segmentCode][identity] = totals.segments[segmentCode][identity] ? totals.segments[segmentCode][identity] : deepCopy(blankKpis);;

                    let columnDetail = columnDetails.find((col) => col.mainKey === identity);
                    tmp.value[identity] = deepCopy(blankKpis);
                    if (columnDetail && columnDetail.calculate) {
                        if (columnDetail.colc_id && columnDetail.colc_id !== data_id) {
                            let helperData = getHelperData(columnDetail.colc_id)();
                            // debugger;
                            if (helperData && helperData.data && helperData.data.length) {
                                let filteredData = [];
                                if (helperData.data[0].index) {
                                    if (date) {
                                        filteredData = helperData.data.filter((d) => moment(d.index.date).isSame(date, 'day'))
                                    }
                                    if (dba) {
                                        filteredData = helperData.data.filter((d) => d.index.dba === dba)
                                    }
                                }
                                //This is for forecast data only
                                if (helperData.data[0].stay_date) {
                                    if (date) {
                                        filteredData = helperData.data.filter((d) => moment(d.stay_date).isSame(date, 'day'))
                                    }
                                    if (dba) {
                                        filteredData = helperData.data.filter((d) => d.dba === dba)
                                    }
                                }

                                tmp.value[identity] = columnDetail.calculate(deepCopy(filteredData), workspace_controls, { original_item, date, dba, identity, segmentCode });
                                // tmp.value[identity] = {};

                                // debugger;
                                // if(!tmp.value[identity]) debugger;
                                let kpis = Object.keys(tmp.value[identity]);
                                kpis.map((kpi) => {
                                    let kpi_val = tmp.value[identity][kpi];
                                    if (!['date', 'ADR'].includes(kpi)) {
                                        totals.segments[segmentCode][identity][kpi] = sum(checkProperValue(totals.segments[segmentCode][identity][kpi]), Number(kpi_val), 4);
                                    }
                                    if (kpi === 'Occ') {
                                        tmp.value[identity][kpi] = convertToPercent(tmp.value[identity][kpi]);
                                    }
                                });

                                totals.segments[segmentCode][identity].ADR = !isNaN(totals.segments[segmentCode][identity].Revenue / totals.segments[segmentCode][identity].Rooms) ? totals.segments[segmentCode][identity].Revenue / totals.segments[segmentCode][identity].Rooms : 0;
                                totals.segments[segmentCode][identity].Occ = !isNaN(totals.segments[segmentCode][identity].Rooms / totals.capacity) ? totals.segments[segmentCode][identity].Rooms / totals.capacity : 0;
                                totals.segments[segmentCode][identity].Occ = convertToPercent(totals.segments[segmentCode][identity].Occ);
                            }

                        } else {
                            // debugger;
                            tmp.value[identity] = columnDetail.calculate(deepCopy(tmp.value), workspace_controls, { original_item, date, dba, identity, segmentCode });
                            // totals.segments[segmentCode][identity] = columnDetail.calculate(deepCopy(totals.segments[segmentCode]), workspace_controls, { original_item, date, dba, identity, segmentCode });
                        }
                    }
                });

                segmented.push(tmp);
            }

            //Handle in case of no segment mode
            if (!hasSegmented && totalKey) {
                let tmp = {};
                totals.segments[segmentCode] = totals.segments[segmentCode] ? totals.segments[segmentCode] : {};
                // total = item[totalKey];

                let allidentifiers = Object.keys(item[totalKey]);
                allidentifiers.map((identity, i) => {
                    // const [tileName, columnId, identity] = unique_identity.split('->');
                    total[identity] = total[identity] ? total[identity] : {};
                    totals.grand[identity] = totals.grand[identity] ? totals.grand[identity] : {};

                    if (!ignoreIdentities.includes(identity)) {
                        let kpis = Object.keys(item[totalKey][identity]);
                        kpis.map((kpi) => {
                            totals.grand[identity][kpi] = totals.grand[identity][kpi] ? totals.grand[identity][kpi] : 0;
                            total[identity][kpi] = total[identity][kpi] ? total[identity][kpi] : 0;
                            let kpi_val = Number(item[totalKey][identity][kpi]);
                            // total.capacity = capacity;

                            if (!['compdate', 'ADR'].includes(kpi)) {
                                total[identity][kpi] = kpi_val;
                                totals.grand[identity][kpi] = sum(totals.grand[identity][kpi], Number(kpi_val), 13);
                            }
                            if (kpi === 'Occ') {
                                total[identity][kpi] = convertToPercent(total[identity][kpi]);
                            }
                            //Do for pace comparison date
                            if (kpi === 'compdate') {
                                // debugger;
                                total[identity].compdate = item.value[identity].compdate;
                                // delete total[identity].date;
                            }
                        });

                        //Calculating ADR, Occ and RevPAR for grand total
                        total[identity].ADR = !isNaN(total[identity].Revenue / total[identity].Rooms) ? total[identity].Revenue / total[identity].Rooms : 0;
                        
                        totals.grand[identity].ADR = !isNaN(totals.grand[identity].Revenue / totals.grand[identity].Rooms) ? totals.grand[identity].Revenue / totals.grand[identity].Rooms : 0;
                        totals.grand[identity].Occ = !isNaN(totals.grand[identity].Rooms / totals.capacity) ? totals.grand[identity].Rooms / totals.capacity : 0;
                        totals.grand[identity].RevPAR = !isNaN(totals.grand[identity].Revenue / totals.capacity) ? totals.grand[identity].Revenue / totals.capacity : 0;
                    }
                });

                ignoreIdentities.map((identity, i) => {
                    // const [tileName, columnId, identity] = unique_identity.split('->');
                    total[identity] = total[identity] ? total[identity] : {};
                    totals.grand[identity] = totals.grand[identity] ? totals.grand[identity] : {};

                    //Add calculation based identity
                    let columnDetail = columnDetails.find((col) => col.mainKey === identity);

                    if (columnDetail && columnDetail.calculate) {
                        if (columnDetail.colc_id && columnDetail.colc_id !== data_id) {
                            let helperData = getHelperData(columnDetail.colc_id)();
                            // debugger;
                            if (helperData && helperData.data && helperData.data.length) {
                                let filteredData = [];
                                if (helperData.data[0].index) {
                                    if (date) {
                                        filteredData = helperData.data.filter((d) => moment(d.index.date).isSame(date, 'day'))
                                    }
                                    if (dba) {
                                        filteredData = helperData.data.filter((d) => d.index.dba === dba)
                                    }
                                }
                                //This is for forecast data only
                                if (helperData.data[0].stay_date) {
                                    if (date) {
                                        filteredData = helperData.data.filter((d) => moment(d.stay_date).isSame(date, 'day'))
                                    }
                                    if (dba) {
                                        filteredData = helperData.data.filter((d) => d.dba === dba)
                                    }
                                }

                                if (filteredData.length) {
                                    total[identity] = columnDetail.calculate(deepCopy(filteredData), workspace_controls, { original_item, date, dba, identity });
                                }

                                let kpis = Object.keys(total[identity]);
                                kpis.map((kpi) => {
                                    let kpi_val = Number(total[identity][kpi]);
                                    if (!['date', 'ADR'].includes(kpi)) {
                                        totals.grand[identity][kpi] = sum(checkProperValue(totals.grand[identity][kpi]), Number(kpi_val), 4);
                                    }
                                    if (kpi === 'Occ') {
                                        total[identity][kpi] = convertToPercent(total[identity][kpi]);
                                    }
                                });
                                // debugger
                                totals.grand[identity].ADR = !isNaN(totals.grand[identity].Revenue / totals.grand[identity].Rooms) ? totals.grand[identity].Revenue / totals.grand[identity].Rooms : 0;
                                totals.grand[identity].Occ = !isNaN(totals.grand[identity].Rooms / totals.capacity) ? totals.grand[identity].Rooms / totals.capacity : 0;
                                totals.grand[identity].Occ = convertToPercent(totals.grand[identity].Occ);
                            }
                        } else {
                            // debugger;
                            total[identity] = columnDetail.calculate(deepCopy(total), workspace_controls, { original_item, date, dba, identity });
                            totals.grand[identity] = columnDetail.calculate(deepCopy(totals.grand), workspace_controls, { original_item, date, dba, identity });
                        }
                    }

                });
            }
        });

        //Calculating total of segments
        // debugger
        segmented.map((item, index) => {
            // debugger;
            let allidentifiers = Object.keys(item.value);
            allidentifiers.map((identity, i) => {
                // const [tileName, columnId, identity] = unique_identity.split('->');
                total[identity] = total[identity] ? total[identity] : {};
                totals.grand[identity] = totals.grand[identity] ? totals.grand[identity] : {};
                // debugger;
                if (!ignoreIdentities.includes(identity)) {
                    let kpis = Object.keys(item.value[identity]);
                    kpis.map((kpi) => {
                        totals.grand[identity][kpi] = totals.grand[identity][kpi] ? totals.grand[identity][kpi] : 0;
                        total[identity][kpi] = total[identity][kpi] ? total[identity][kpi] : 0;

                        if (!['compdate', 'ADR'].includes(kpi)) {
                            total[identity][kpi] = sum(total[identity][kpi], Number(item.value[identity][kpi]), 13);
                            totals.grand[identity][kpi] = sum(totals.grand[identity][kpi], Number(item.value[identity][kpi]), 13);
                        }
                        //Do for pace comparison date
                        if (kpi === 'compdate') {
                            // debugger;
                            total[identity].compdate = item.value[identity].compdate;
                            // delete total[identity].date;
                        }
                    });
                    // debugger;
                    //Calculating ADR, Occ and RevPAR for total

                    total[identity].ADR = !isNaN(total[identity].Revenue / total[identity].Rooms) ? total[identity].Revenue / total[identity].Rooms : 0;

                    //Adding SellRates if available in HotelTotal/MarketTotal
                    total[identity].SellRate = original_item[totalKey] && original_item[totalKey][identity] && original_item[totalKey][identity].SellRate ? original_item[totalKey][identity].SellRate : 0;
                    //Doing this as sellrate is not available in segmented mode
                    if (totalKey === 'MarketTotal') {
                        let helperData = getHelperData('MarketARI')().data;
                        let filteredData = helperData.find(item => moment(item.index.date).isSame(date, 'day'))
                        total[identity].SellRate = filteredData ? filteredData[totalKey].primary.SellRate : 0;
                    }

                    //Calculating ADR, Occ and RevPAR for grand total
                    totals.grand[identity].ADR = !isNaN(totals.grand[identity].Revenue / totals.grand[identity].Rooms) ? totals.grand[identity].Revenue / totals.grand[identity].Rooms : 0;
                    totals.grand[identity].Occ = !isNaN(totals.grand[identity].Rooms / totals.capacity) ? totals.grand[identity].Rooms / totals.capacity : 0;
                    totals.grand[identity].RevPAR = !isNaN(totals.grand[identity].Revenue / totals.capacity) ? totals.grand[identity].Revenue / totals.capacity : 0;
                }
            });

            ignoreIdentities.map((identity, i) => {
                // const [tileName, columnId, identity] = unique_identity.split('->');
                total[identity] = total[identity] ? total[identity] : {};
                totals.grand[identity] = totals.grand[identity] ? totals.grand[identity] : {};

                //Add calculation based identity
                // debugger;
                let columnDetail = columnDetails.find((col) => col.mainKey === identity);
                let subcol_SellRate = columnDetail.subcolumns.find((sub) => sub.value === 'SellRate');
                // item.value[identity] = deepCopy(blankKpis);
                if (columnDetail && columnDetail.calculate) {
                    // item.value[identity] = columnDetail.calculate(deepCopy(item.value), workspace_controls);

                    // debugger;

                    if (columnDetail.colc_id && columnDetail.colc_id !== data_id) {
                        let kpis = Object.keys(item.value[identity]);
                        // debugger;
                        kpis.map((kpi) => {
                            totals.grand[identity][kpi] = totals.grand[identity][kpi] ? totals.grand[identity][kpi] : 0;
                            total[identity][kpi] = total[identity][kpi] ? total[identity][kpi] : 0;
                            // total.capacity = capacity;

                            if (!['compdate', 'ADR'].includes(kpi)) {
                                total[identity][kpi] = sum(total[identity][kpi], Number(item.value[identity][kpi]), 13);
                                totals.grand[identity][kpi] = sum(totals.grand[identity][kpi], Number(item.value[identity][kpi]), 13);
                            }
                            //Do for pace comparison date
                            if (kpi === 'compdate') {
                                // debugger;
                                total[identity].compdate = item.value[identity].compdate;
                                // delete total[identity].date;
                            }
                        });
                        
                        let ADR = total[identity].Revenue / total[identity].Rooms;
                        let SellRate = total.primary ? total.primary.SellRate : 0;
                        total[identity].ADR = isNaN(ADR) ? 0 : ADR;
                        if (subcol_SellRate) total[identity].SellRate = isNaN(SellRate) ? 0 : SellRate;
                    } else {
                        total[identity] = columnDetail.calculate(deepCopy(total), workspace_controls, { original_item, date, dba, identity });
                        // totals.grand[identity] = columnDetail.calculate(deepCopy(totals.grand), workspace_controls, { original_item, date, dba, identity });
                    }
                }

            });
        });

        //Do for compset data
        if (compset_median_col) {
            total[compset_median_col.mainKey] = {};
            let compSellRates = [];
            compset_median_col.subcolumns.map((subcol) => {
                if (subcol.value !== 'CM') {
                    total[compset_median_col.mainKey][subcol.value] = (original_item && original_item[subcol.value]) ? original_item[subcol.value] : 0;
                   let sellRate_val = (original_item && original_item[subcol.value]) ? original_item[subcol.value].sell_rate : 0;
                    compSellRates.push(sellRate_val);
                }
            });
            total[compset_median_col.mainKey]['CM'] = getCompsetMedian(compSellRates);
        }
        //Do for market_sell_rates data
        if (market_sell_rates) {
            // total[market_sell_rates.mainKey] = {};
            columns.map((col) => {
                // debugger;
                if (col.type !== "dateColumn") {
                    total[col.mainKey] = total[col.mainKey] ? total[col.mainKey] : {};
                    total[col.mainKey][col.k] = {};
                    col.subcolumns.map((subcol) => {
                        total[col.mainKey][col.k][subcol.value] = original_item[col.mainKey][col.k] ? original_item[col.mainKey][col.k][subcol.value] : 0;
                    });
                }

            });
        }

        //Returning item object
        // debugger
        segmented.sort((a, b) => {
            let B = b.value[segmentSortidentifier] ? b.value[segmentSortidentifier].Rooms : 0;
            let A = a.value[segmentSortidentifier] ? a.value[segmentSortidentifier].Rooms : 0;
            return B - A;
        })
        const finalObject = {
            index: deepCopy(item.index),
            segmented: segmented,
            // HotelTotal: item.HotelTotal,
            total: total
        };
        
        //Adding total key like 'HotelTotal' or MarketTotal
        
        if (totalKey && item[totalKey]){
            finalObject[totalKey] = item[totalKey];
            if(tile==='forecast' && item[totalKey].userforecastdata){
                finalObject.total.userforecastdata = item[totalKey].userforecastdata;
                finalObject.segmented.filter(({value}, index)=>{
                    // debugger
                    if(value.userforecastdata){
                        finalObject.total.difference = finalObject.segmented[index].value.difference;
                    }
                    finalObject.segmented[index].value.userforecastdata = {ADR:0, Rooms:0, Occ:0, Revenue:0, RevPAR:0, SellRate:0};
                    finalObject.segmented[index].value.difference = {ADR:0, Rooms:0, Occ:0, Revenue:0, RevPAR:0, SellRate:0};
                })
            }
        }
        if (date_dba === 'date') {
            if (item.index && item.index[date_dba]) finalObject.index.dow = new moment(item.index[date_dba]).format('ddd');
            // debugger;
            if (filters && filters.dow && finalObject.index && finalObject.index.dow && (filters.dow.includes('all') || filters.dow.includes(finalObject.index.dow.toLocaleLowerCase()))) {
                transformed.push(finalObject);
            }
        }

        if (workspace_controls.scopeType === 'Dba') {
            transformed.push(finalObject);
        }
    });
    //Adding segmented grand total
    // debugger;
    if (workspace_controls.segmented_view) {
        let segmtsKeys = Object.keys(totals.segments);
        let segmentedGrandTotal = { index: { date: '', dow: '' }, segmented: [], total: totals.grand };
        if(date_dba === 'dba'){
            segmentedGrandTotal.index.dba =  '';
            delete segmentedGrandTotal.index.date;
            delete segmentedGrandTotal.index.dow;
        }
        segmtsKeys.map((item, i) => segmentedGrandTotal.segmented.push({ name: item, value: totals.segments[item] }));
        // segmentedGrandTotal.segmented.sort((a, b) => (b.value[segmentSortidentifier].Rooms - a.value[segmentSortidentifier].Rooms));
        segmentedGrandTotal.segmented.sort((a, b) => {
            if((b.value[segmentSortidentifier] && b.value[segmentSortidentifier].Rooms) && (a.value[segmentSortidentifier] && a.value[segmentSortidentifier].Rooms)){
               return (b.value[segmentSortidentifier].Rooms - a.value[segmentSortidentifier].Rooms)
            }
        });
        transformed.push(segmentedGrandTotal);
    }

    return {
        totals,
        data: transformed
    }
    console.log("time taken:", moment().format("x") - start, totals, transformed);
}

function downloadReportToExcel(app_state, active_tiles, selectedPropertyName) {
    let exportFileName = moment(app_state.as_of_date).format('MMM DD YYYY') + "_" + selectedPropertyName + "_" + active_tiles[0];
    if (app_state.workspace_controls.downloadExportButton === true) {
        let sheetName = active_tiles[0] ? active_tiles[0] : " ";
        TableToExcel.convert(document.getElementById("mainTable"), {
            name: exportFileName + ".xlsx",
            sheet: {
                name: sheetName.toUpperCase()
            }
        });
    }
}

//Helper functions
const getFilteredData = (params) => {
    // debugger;
    // {data:data_setup, sortBy: 'Occ', parent: 'otb_prior'};
    const { data, columns } = params;
    const filteredColumns = getFilteredColumns(columns);
    let filtereddData = deepCopy(data);
    if (!filteredColumns.length) {
        return filtereddData;
    }
    // debugger
    filtereddData = [];
    let pushedRow = [];
    data.map((row, i) => {
        for (let j = 0; j < row.length; j++) {
            for (let k = 0; k < filteredColumns.length; k++) {
                let { parent, value, filter } = filteredColumns[k];
                if (row[j].id === parent) {
                    // debugger
                    let rowData = null;
                    if (filter) {
                        let dataValue = row[j][value];
                        if (typeof dataValue !== 'number' && dataValue.indexOf('%') !== -1) {
                            dataValue = Number(dataValue.replaceAll(/%/g, ''));
                        }
                        if (filter.gte && filter.lte) {
                            if (dataValue >= Number(filter.gte) && dataValue <= filter.lte) {
                                rowData = row;
                            }
                        } else {
                            if (filter.gte && dataValue >= Number(filter.gte)) {
                                rowData = row;
                            }
                            if (filter.lte && dataValue <= filter.lte) {
                                rowData = row;
                            }
                        }

                        if (pushedRow.indexOf(i) === -1 && rowData) {
                            filtereddData.push(rowData);
                            pushedRow.push(i);
                        }
                    }
                }
            }
        }
    });
    // debugger;
    return filtereddData;
}

const sortData = (params) => {
    // {data:data_setup, sortBy: 'Occ', parent: 'otb_prior'};
    const { data, sortBy, parent, order } = params;
    const sortedData = deepCopy(data);
    if (!order) {
        return sortedData;
    }
    let sortedParentIndex = null;
    if (sortedData[0]) {
        sortedData[0].map((item, i) => {
            if (item.id === parent) {
                sortedParentIndex = i;
            }
        });
        let weekdaysShort = moment.weekdaysShort();
        //  debugger;
        sortedData.sort((a, b) => {
            if (sortedParentIndex !== null) {
                let A = a[sortedParentIndex][sortBy];
                let B = b[sortedParentIndex][sortBy];
                //This is added for Pickup variance to sdly column
                A = (A) ? A : 0;
                B = (B) ? B : 0;
                // console.log("a=> ", A);

                if (typeof A !== 'number' && A.indexOf('%') !== -1) {
                    A = Number(A.replaceAll(/%/g, ''));
                }
                if (typeof B !== 'number' && B.indexOf('%') !== -1) {
                    B = Number(B.replaceAll(/%/g, ''));
                }
                //---
                if ((sortBy === 'date') || (sortBy === 'compdate')) {
                    A = moment(A).format('x');
                    B = moment(B).format('x');
                }
                if (sortBy === 'dow') {
                    A = weekdaysShort.indexOf(A);
                    B = weekdaysShort.indexOf(B);
                }

                if (order === 'asc') {
                    return A - B;
                }
                if (order === 'desc') {
                    return B - A;
                }
            }
        });
    }
    return sortedData;
}

const getSortedColumn = (columns) => {
    //Get sorted column details from column configuration
    let sortedColumn = {};
    columns.map((main, i) => {
        main.subcolumns.map((sub, j) => {
            //it depends on property sorted
            if (sub.sorted) {
                sortedColumn = sub;
            }
        });
    });
    return sortedColumn;
};

const getFilteredColumns = (columns) => {
    //Get filter column details from column configuration
    let filteredColumns = [];
    columns.map((main, i) => {
        let subcols = main.subcolumns;
        for (let j = 0; j < subcols.length; j++) {
            let sub = subcols[j];
            if (sub.filterable && sub.filter && (sub.filter.gte || sub.filter.lte)) {
                filteredColumns.push(sub);
            }
        }
    });
    // debugger;
    return filteredColumns;
};

const ColumnSorting = (props) => {
    const { colItem, sortable, onOrderByChange, sorted, label, value } = props;

    const onClickHandler = (ev) => {
        // debugger;
        if (!sorted) {
            colItem.sorted = 'asc';
        }
        if (sorted === 'asc') {
            colItem.sorted = 'desc';
        }
        if (sorted === 'desc') {
            colItem.sorted = null;
        }
        onOrderByChange(colItem);
    }

    if (!sortable) {
        return (<></>);
    }
    return (
        <div style={{ position: 'relative' }}>
            <Tooltip title={"Sort by " + label} arrow>
                <Button className={props.className + ' order-' + colItem.sorted} onClick={onClickHandler}>
                    <ArrowDropUpIcon className='order-arrow order-arrow-up' />
                    <ArrowDropDownIcon className='order-arrow order-arrow-down' />
                </Button>
            </Tooltip>

        </div>

    );
}

export default { downloadReportToExcel, getFilteredData, sortData, getSortedColumn, getFilteredColumns, getFilteredColumns, ColumnSorting };